module.exports = "/fast-coin/img/coin/anim/shine_1/shine_1_017.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img/coin/anim/shine_1/shine_1_017.png
// module id = 2333
// module chunks = 5